import React from 'react';

import { CmBox, CmFlex, CmText } from '@/components/uiParts';
import { CmTag } from '@/components/uiParts/Tag/CmTag';
import {
  deliveryServiceBadge,
  EMPTY_VALUE,
  orderStatusColor,
  orderStatusLabel,
  orderStatusTone,
} from '@/pages/externals/mos-pos-resend/service';
import { MosPosOrderStatus } from '@/services/MosPosOrder/type';

type OrderStatusBadgeProps = {
  status: MosPosOrderStatus;
};

/** 注文ステータスバッジ (一覧・詳細で共通) */
export const OrderStatusBadge: React.VFC<OrderStatusBadgeProps> = ({
  status,
}) => {
  const tone = orderStatusColor[orderStatusTone[status]];
  if (tone === undefined) return <CmText>{EMPTY_VALUE}</CmText>;

  return (
    <CmFlex
      display="inline-flex"
      alignItems="center"
      bg={tone.bg}
      color={tone.color}
      borderRadius="full"
      padding="4px 10px"
    >
      <CmBox
        width="6px"
        height="6px"
        borderRadius="full"
        bg={tone.dot}
        mr="6px"
      />
      <CmText fontSize="12px" fontWeight="bold" color={tone.color}>
        {orderStatusLabel[status]}
      </CmText>
    </CmFlex>
  );
};

type DeliveryServiceBadgeProps = {
  deliveryServiceId: number;
};

/** デリバリーサービスバッジ。CmTag は colorScheme 前提なので bg / color を直接渡す。 */
export const DeliveryServiceBadge: React.VFC<DeliveryServiceBadgeProps> = ({
  deliveryServiceId,
}) => {
  const badge = deliveryServiceBadge[deliveryServiceId];
  if (badge === undefined) return <CmText>{EMPTY_VALUE}</CmText>;

  return (
    // CmTag の既定は borderRadius="full" (ピル形) だが、
    // 画面設計書 No.11 / No.18 の .badge-svc は角丸 4px の矩形なので上書きする。
    <CmTag size="sm" bg={badge.bg} color={badge.color} borderRadius="4px">
      {badge.label}
    </CmTag>
  );
};
